export default function WorkConditions() {
  const requirements = [
    { label: '資格', value: '20歳〜40歳位までの女性（経験者優遇・未経験歓迎）' },
    { label: '給与', value: '完全歩合制（50％〜70％）※最低保証あり、全額日払い可' },
    { label: '時間', value: '11:00～25:00の間で自由シフト（1日4h〜/週1日〜OK）' },
    { label: '勤務地', value: '大阪市中央区千日前1-9-12　ゴールドビル4F（各線日本橋駅・難波駅から徒歩8分）' },
    { label: '待遇', value: '交通費支給、深夜送迎あり、制服貸与、無料研修制度' }
  ];

  return (
    <section id="conditions" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block text-pink-500 font-bold text-sm mb-3 tracking-wider">REQUIREMENTS</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">募集要項</h2>
        </div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="divide-y divide-gray-100">
            {requirements.map((item, index) => (
              <div key={index} className="flex flex-col sm:flex-row">
                <div className="sm:w-1/3 bg-pink-50/50 p-6 flex items-center sm:justify-center font-bold text-gray-700">
                  {item.label}
                </div>
                <div className="sm:w-2/3 p-6 text-gray-600 flex items-center">
                  {item.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
